import { computed, inject, Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { injectQuery } from '@tanstack/angular-query-experimental';
import { ActivityTypeService, ActivityTypeSummary } from '../../../../api';
import { QueryKey } from '../../../constants/query-key';

@Injectable()
export class ActivityTypeQueryService {
  private readonly activityTypeService = inject(ActivityTypeService);

  activityTypesQuery = injectQuery(() => ({
    queryKey: [QueryKey.ACTIVITY_TYPES],
    queryFn: () => lastValueFrom(this.activityTypeService.getActivityTypes()),
  }));

  activityTypes = computed<ActivityTypeSummary[]>(() => this.activityTypesQuery.data()?.activityTypes ?? []);
}
